import React from 'react'
import { NavLink } from 'react-router-dom';

import { FaLocationDot } from "react-icons/fa6";
import { FaPhone } from "react-icons/fa6";
import { BiLogoGmail } from "react-icons/bi";
import { FaLinkedinIn } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa6";
import { AiFillInstagram } from "react-icons/ai";
import { FaTwitter } from "react-icons/fa";

function Footer() {

  // Footer Company Info
  const iconStyle = 'self-center mx-4 text-xl';
  const companyInfoData = [
    { path: 'tel:8883506605', icon: <FaPhone className={iconStyle} />, name: '888-350-6605' },
    { path: 'mailto:benefits@insuranceenterpriseusa.com', icon: <BiLogoGmail className={iconStyle} />, name: 'benefits@insuranceenterpriseusa.com' },
    { path: 'https://www.linkedin.com/company/insurance-enterprise/', icon: <FaLinkedinIn className={iconStyle} />, name: 'See our LinkedIn Profile' },
    { path: 'https://www.facebook.com/InsuranceEnterprise', icon: <FaFacebookF className={iconStyle} />, name: 'Visit Us on Facebook' },
    { path: 'https://www.instagram.com/insuranceenterprise/', icon: <AiFillInstagram className={iconStyle} />, name: 'See us on Instagram' },
    { path: 'https://twitter.com/IEnsurance_USA', icon: <FaTwitter className={iconStyle} />, name: 'Visit Us on Twitter' },
  ];

  const companyInfoList = companyInfoData.map((listItem) => (
    <li className='flex my-2' key={listItem.name} >{listItem.icon} <a href={listItem.path} target='_blank' rel='noreferrer' className='hover:underline hover:text-white transition-colors duration-150'>{listItem.name}</a></li>
  ));



  // Footer Useful Links
  const useFullLinksData = [
    { path: 'online-quotes', name: 'Individual & Family Health Insurance' },
    { path: 'group-health', name: 'Small Business Health Insurance' },
    { path: 'faqs', name: 'FAQs' },
    { path: 'contact-us', name: 'Contact Us' },
    { path: 'privacy-policy', name: 'Privacy Policy' },
    { path: 'terms-and-condition', name: 'Terms & Conditions' },
  ];

  const useFullLinksList = useFullLinksData.map((listItem) => (
    <NavLink to={listItem.path} key={listItem.name} onClick={() => window.scrollTo(0, 0)}>
      <p className='hover:underline hover:text-white transition-colors duration-150 my-1 text-base'>{listItem.name}</p>
    </NavLink>
  ));

  return (
    <>

      {/* Upper Footer */}
      <div className='layout-spacing justify-center py-16 bg-accent text-neutral-content overflow-hidden'>
        <footer className="layout-width footer">
          <div>
            <div className='text-3xl font-bold'>Company Info</div>
            <ul className='text-base-200'>
              <li className='flex my-2'><i><FaLocationDot className={iconStyle} /></i> Licensed in 34 States</li>
              {companyInfoList}
            </ul>
          </div>
          <div>
            <div className='text-3xl font-bold'>Useful Links</div>
            <ul className='flex flex-col items-start text-base-200'>{useFullLinksList}</ul>
          </div>
        </footer>
      </div>

      {/* Lower Footer */}
      <footer className="footer footer-center p-4 bg-primary text-base-200">
        Copyright © {new Date().getFullYear()} Insurance Enterprise, All Rights Reserved
      </footer>

    </>
  )
}

export default Footer